<template>
  <v-sheet
    height="100dvh"
    class="overflow-auto mapBack fullVH"
    :style="`background-image: url(${backcontour});`"
  >
    <v-parallax
      alt="Website Background"
      height="100dvh"
      class="d-flex align-center fullVH"
      :style="`padding-bottom: ${
        height < 501 ? '80' : width > 800 ? '200' : '100'
      }px`"
      :src="backemo"
    >
      <v-card
        v-if="!hideVideoAlert"
        color="white"
        class="d-flex pa-1 rounded-circle alertNew"
        :class="`status${alertNewStatus}`"
        width="100"
        height="100"
        elevation="4"
        @click="alertNewStatus = alertNewStatus === 0 ? 1 : alertNewStatus"
      >
        <v-sheet
          class="d-flex rounded-circle pa-4 text-white flex-column align-center justify-end"
          color="rgb(129, 162, 19)"
          width="100%"
          height="100%"
        >
          <v-icon color="white" class="mb-2">mdi-movie-open</v-icon>
        </v-sheet>
      </v-card>
      <div class="alertNew" :class="`status${alertNewStatus}`">
        <div class="promoText">
          Die Videopräsentation zum Waldatlas:<a
            href="https://www.youtube.com/shorts/Z4Qvr9cekeg"
            target="_blank"
            >Jetzt auf Youtube ansehen</a
          >
        </div>
        <div class="promoClose">
          <span @click="hideVideoAlert = !hideVideoAlert"
            ><v-icon class="mr-1 mb-1" size="13">{{
              hideVideoAlert
                ? 'mdi-checkbox-outline'
                : 'mdi-checkbox-blank-outline'
            }}</v-icon
            >Nicht mehr anzeigen</span
          >
          <span @click="alertNewStatus = 0">Schließen</span>
        </div>
      </div>
      <v-sheet
        class="bg-transparent flex-column align-end w-100"
        :class="width < 600 ? '' : width > 800 ? 'px-16' : 'px-3'"
      >
        <v-img
          alt="Logo Waldatlas"
          class="mx-auto mt-8 mb-8"
          :width="height > 500 ? '90%' : '40%'"
          max-width="600"
          :src="logowaldatlas"
        />
        <v-sheet
          class="d-flex bg-transparent text-white justify-center text-center strokeme"
          :class="
            height < 501 ? 'text-body-2' : width > 800 ? 'text-h6' : 'text-body'
          "
        >
          Österreichs interaktive Kartensammlung zu den Themen Wald,
          Naturgefahren und Biodiversität</v-sheet
        >
        <v-sheet
          class="d-flex bg-transparent text-white justify-center text-center strokeme"
          :class="
            height < 501
              ? 'text-body-2'
              : width > 800
              ? 'text-h6 mt-8'
              : 'text-body mt-8'
          "
        >
          bundesweit . qualitätsgesichert . kostenfrei</v-sheet
        >
      </v-sheet>
    </v-parallax>
    <v-sheet
      class="d-flex bg-transparent flex-row align-stretch justify-space-between pb-6 mx-auto"
      max-width="1000"
      :style="`margin-top: ${
        height < 501
          ? '-55'
          : width > 800
          ? '-110'
          : width > 600
          ? '-70'
          : '-55'
      }px`"
    >
      <v-card
        color="white"
        class="d-flex pa-1 rounded-circle"
        :class="width > 700 ? 'mx-6' : 'mx-1'"
        :to="{ path: `/information/ueberwaldatlas` }"
        :width="
          height < 501
            ? '110'
            : width > 800
            ? '200'
            : width > 600
            ? '150'
            : '110'
        "
        :height="
          height < 501
            ? '110'
            : width > 800
            ? '200'
            : width > 600
            ? '150'
            : '110'
        "
        elevation="4"
      >
        <v-sheet
          class="d-flex rounded-circle pa-4 text-white flex-column align-center justify-end"
          color="rgb(1,77,51)"
          width="100%"
          height="100%"
        >
          <v-icon
            v-if="width > 600 && height > 500"
            :size="width > 800 ? '70' : '40'"
            color="white"
            >mdi-information-box</v-icon
          >
          <h3
            class="text-white text-center mt-2 text-button"
            :class="
              height < 501
                ? 'mb-4'
                : width > 800
                ? 'mb-6'
                : width > 600
                ? 'mb-4'
                : 'mb-4'
            "
            style="line-height: 1.3em"
          >
            Über<br />Waldatlas
          </h3>
        </v-sheet>
      </v-card>
      <v-card
        color="white"
        class="d-flex pa-1 rounded-circle"
        :class="width > 700 ? 'mx-6' : 'mx-1'"
        :to="{ path: `/topics` }"
        :width="
          height < 501
            ? '110'
            : width > 800
            ? '200'
            : width > 600
            ? '150'
            : '110'
        "
        :height="
          height < 501
            ? '110'
            : width > 800
            ? '200'
            : width > 600
            ? '150'
            : '110'
        "
        elevation="4"
      >
        <v-sheet
          class="d-flex rounded-circle pa-4 text-white flex-column align-center justify-end"
          color="rgb(112,131,112)"
          width="100%"
          height="100%"
        >
          <v-icon
            v-if="width > 600 && height > 500"
            :size="width > 800 ? '70' : '40'"
            color="white"
            >mdi-view-grid</v-icon
          >
          <h3
            class="text-white text-center mt-2 text-button"
            :class="
              height < 501
                ? 'mb-0'
                : width > 800
                ? 'mb-6'
                : width > 600
                ? 'mb-4'
                : 'mb-0'
            "
            style="line-height: 1.3em"
          >
            Themen<br />und Suche
          </h3>
        </v-sheet>
      </v-card>
      <v-card
        color="white"
        class="d-flex pa-1 rounded-circle"
        :class="width > 700 ? 'mx-6' : 'mx-1'"
        :to="{ path: `/map/${randomMapId}` }"
        :width="
          height < 501
            ? '110'
            : width > 800
            ? '200'
            : width > 600
            ? '150'
            : '110'
        "
        :height="
          height < 501
            ? '110'
            : width > 800
            ? '200'
            : width > 600
            ? '150'
            : '110'
        "
        elevation="4"
      >
        <v-sheet
          class="d-flex rounded-circle pa-4 text-white flex-column align-center justify-end"
          color="rgb(129,162,19)"
          width="100%"
          height="100%"
        >
          <v-icon
            v-if="width > 600 && height > 500"
            :size="width > 800 ? '70' : '40'"
            color="white"
            >mdi-map</v-icon
          >
          <h3
            class="text-white text-center mt-2 text-button"
            :class="
              height < 501
                ? 'mb-4'
                : width > 800
                ? 'mb-6'
                : width > 600
                ? 'mb-4'
                : 'mb-4'
            "
            style="line-height: 1.3em"
          >
            Beispiel<br />Karte
          </h3>
        </v-sheet>
      </v-card>
    </v-sheet>

    <v-sheet
      class="pb-16 bg-transparent"
      :class="width < 1000 ? 'px-3' : 'px-16'"
    >
      <v-sheet
        width="100%"
        :max-width="width < 1000 ? '100%' : '1700px'"
        class="bg-transparent d-flex flex-row mx-auto mt-10 justify-space-between"
      >
        <v-card
          v-if="width > 700"
          elevation="0"
          aria-label="Ueber Waldatlas"
          width="35%"
          class="rounded-0 bg-transparent"
          :to="{ path: `/information/ueberwaldatlas` }"
        >
          <v-sheet
            width="100%"
            height="100%"
            class="symbolBack bg-transparent"
            :style="`background-image: url(${symbolabout})`"
          />
        </v-card>
        <v-card
          :width="width > 700 ? '60%' : '100%'"
          min-height="280"
          class="rounded-0 pa-0 naviCard"
          color="rgba(255,255,255,.7)"
          elevation="1"
          :to="{ path: `/information/ueberwaldatlas` }"
        >
          <partial-frame color="rgb(1,77,51)" />
          <v-sheet
            class="d-inline-block pl-2 pr-4 text-button"
            color="rgba(1,77,51,1)"
          >
            <v-icon class="pb-1" size="24" color="white"
              >mdi-information-box</v-icon
            >
            <span style="color: white" class="ml-3 biggerFontSize"
              >Über Waldatlas</span
            >
          </v-sheet>

          <information
            class="pa-3 mt-3"
            pagecontent="startseite-button-ueberuns"
          />
        </v-card>
      </v-sheet>

      <v-sheet
        width="100%"
        :max-width="width < 1000 ? '100%' : '1700px'"
        class="bg-transparent d-flex flex-row mx-auto mt-10 justify-space-between"
      >
        <v-card
          :width="width > 700 ? '60%' : '100%'"
          min-height="280"
          class="rounded-0 pa-0 naviCard"
          color="rgba(255,255,255,.7)"
          elevation="1"
          :to="{ path: `/topics` }"
        >
          <partial-frame color="rgb(112,131,112)" />

          <v-sheet
            class="d-inline-block pl-2 pr-4 text-button"
            color="rgb(112,131,112)"
          >
            <v-icon class="pb-1" size="24" color="white">mdi-view-grid</v-icon>
            <span style="color: white" class="ml-3 biggerFontSize"
              >Themen und Suche</span
            >
          </v-sheet>

          <information
            class="pa-3 mt-3"
            pagecontent="startseite-button-themen"
          />
        </v-card>
        <v-card
          v-if="width > 700"
          elevation="0"
          aria-label="Themen"
          width="35%"
          class="rounded-0 bg-transparent"
          :to="{ path: `/topics` }"
        >
          <v-sheet
            width="100%"
            height="100%"
            class="symbolBack bg-transparent"
            :style="`background-image: url(${symboltopics})`"
          />
        </v-card>
      </v-sheet>

      <v-sheet
        width="100%"
        :max-width="width < 1000 ? '100%' : '1700px'"
        class="bg-transparent d-flex flex-row mx-auto mt-10 justify-space-between"
      >
        <v-card
          v-if="width > 700"
          elevation="0"
          aria-label="Karte"
          width="35%"
          class="rounded-0 bg-transparent"
          :to="{ path: `/map/${randomMapId}` }"
        >
          <v-sheet
            width="100%"
            height="100%"
            class="symbolBack bg-transparent"
            :style="`background-image: url(${symbolmap})`"
          />
        </v-card>
        <v-card
          :width="width > 700 ? '60%' : '100%'"
          min-height="280"
          class="rounded-0 pa-0 naviCard"
          color="rgba(255,255,255,.7)"
          elevation="1"
          :to="{ path: `/map/${randomMapId}` }"
        >
          <partial-frame color="rgb(129,162,19)" />

          <v-sheet
            class="d-inline-block pl-2 pr-4 text-button"
            color="rgb(129,162,19)"
          >
            <v-icon class="pb-1" size="24" color="white">mdi-map</v-icon>
            <span style="color: white" class="ml-3 biggerFontSize"
              >Beispielkarte</span
            >
          </v-sheet>

          <information
            class="pa-3 mt-3"
            pagecontent="startseite-button-karten"
          />
        </v-card>
      </v-sheet>

      <v-sheet
        width="100%"
        :max-width="width < 1000 ? '100%' : '1700px'"
        class="bg-transparent d-flex mx-auto mt-10 justify-space-between"
        :class="width > 700 ? 'flex-row' : 'flex-column'"
      >
        <v-card
          :width="width > 700 ? '60%' : '100%'"
          min-height="280"
          class="rounded-0 pa-0 naviCard"
          color="rgba(255,255,255,.7)"
          elevation="1"
        >
          <partial-frame color="rgb(1,77,51)" />

          <v-sheet
            class="d-inline-block pl-2 pr-4 text-button"
            color="rgb(1,77,51)"
          >
            <v-icon class="pb-1" size="24" color="white"
              >mdi-bullhorn-outline</v-icon
            >
            <span style="color: white" class="ml-3 biggerFontSize">News</span>
          </v-sheet>

          <information class="pa-3 mt-3" pagecontent="startseite-button-news" />
        </v-card>
        <v-card
          v-if="width > 700"
          elevation="0"
          aria-label="Wissenswertes"
          width="35%"
          class="rounded-0 bg-transparent"
        >
          <v-sheet
            width="100%"
            height="100%"
            class="symbolBack bg-transparent"
            :style="`background-image: url(${symbolnews})`"
          />
        </v-card>
      </v-sheet>

      <v-sheet
        width="100%"
        :max-width="width < 1000 ? '100%' : '1700px'"
        class="bg-transparent d-flex mx-auto mt-10 justify-space-between"
        :class="width > 700 ? 'flex-row' : 'flex-column'"
      >
        <v-card
          v-if="width > 700"
          elevation="0"
          aria-label="Wissenswertes"
          width="35%"
          class="rounded-0 bg-transparent"
          :to="{ path: `/information/wissenswertes` }"
        >
          <v-sheet
            width="100%"
            height="100%"
            class="symbolBack bg-transparent"
            :style="`background-image: url(${symbolknowledge})`"
          />
        </v-card>
        <v-card
          :width="width > 700 ? '60%' : '100%'"
          min-height="280"
          class="rounded-0 pa-0 naviCard"
          color="rgba(255,255,255,.7)"
          elevation="1"
          :to="{ path: `/information/wissenswertes` }"
        >
          <partial-frame color="rgb(112,131,112)" />

          <v-sheet
            class="d-inline-block pl-2 pr-4 text-button"
            color="rgb(112,131,112)"
          >
            <v-icon class="pb-1" size="24" color="white"
              >mdi-message-text</v-icon
            >
            <span style="color: white" class="ml-3 biggerFontSize"
              >Wissenswertes - Fakten und Zahlen</span
            >
          </v-sheet>

          <information
            class="pa-3 mt-3"
            pagecontent="startseite-button-wissenswertes"
          />
        </v-card>
      </v-sheet>

      <v-sheet
        width="100%"
        :max-width="width < 1000 ? '100%' : '1700px'"
        class="bg-transparent d-flex flex-row mx-auto mt-10 justify-space-between"
      >
        <v-card
          :width="width > 700 ? '60%' : '100%'"
          min-height="280"
          class="rounded-0 pa-0 naviCard"
          color="rgba(255,255,255,.7)"
          elevation="1"
          :to="{ path: `/information/plattformen` }"
        >
          <partial-frame color="rgb(129,162,19)" />

          <v-sheet
            class="d-inline-block pl-2 pr-4 text-button"
            color="rgb(129,162,19)"
          >
            <v-icon class="pb-1" size="24" color="white">mdi-web</v-icon>
            <span style="color: white" class="ml-3 biggerFontSize"
              >Weitere Plattformen</span
            >
          </v-sheet>

          <information
            class="pa-3 mt-3"
            pagecontent="startseite-button-plattformen"
          />
        </v-card>
        <v-card
          v-if="width > 700"
          elevation="0"
          aria-label="Plattformen"
          width="35%"
          class="rounded-0 bg-transparent"
          :to="{ path: `/information/plattformen` }"
        >
          <v-sheet
            width="100%"
            height="100%"
            class="symbolBack bg-transparent"
            :style="`background-image: url(${symbolplatforms})`"
          />
        </v-card>
      </v-sheet>
    </v-sheet>

    <pagefooter />
  </v-sheet>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useDisplay } from 'vuetify';
import pagefooter from '../components/TheFooter.vue';
import logowaldatlas from '../assets/logo-waldatlas-weiss.png';
import backemo from '../assets/landing/title_background.jpg';
import symbolabout from '../assets/landing/Infografik_Waldatlas_231018_ohne_HG_Über.png';
import symboltopics from '../assets/landing/Infografik_Waldatlas_231018_ohne_HG_Themen_Suche.png';
import symbolmap from '../assets/landing/Infografik_Waldatlas_231018_ohne_HG_Beispielkarte.png';
import symbolnews from '../assets/landing/Infografik_Waldatlas_231018_ohne_HG_News.png';
import symbolknowledge from '../assets/landing/Infografik_Waldatlas_231018_ohne_HG_Wissenswertes.png';
import symbolplatforms from '../assets/landing/Infografik_Waldatlas_231018_ohne_HG_Weitere_Plattformen.png';
import information from '../components/Information.vue';
import partialFrame from '../components/ThePartialFrame.vue';
import backcontour from '../assets/landing/back-contour-big02.jpg';
import { useRandomMap } from '../composables/useRandomMap.js';

const { width, height } = useDisplay();
const { randomMapId } = useRandomMap();

const alertNewStatus = ref(0);
const hideVideoAlert = ref(false);

onMounted(() => {
  /* activate if needed
  if (localStorage.getItem('hideVideoAlert')) {
    hideVideoAlert.value = localStorage.getItem('hideVideoAlert') === '1';
    }
    */
});

watch(hideVideoAlert, () => {
  localStorage.setItem('hideVideoAlert', hideVideoAlert.value ? '1' : '0');
});
</script>

<style scoped>
.alertNew {
  position: absolute;
  font-size: 14px;
  right: 25px;
  top: 25px;
  z-index: 1000;
}

@media (max-width: 800px) {
  .alertNew {
    right: 5px;
    top: 5px;
  }
}

.alertNew a {
  display: block;
  margin-top: 10px;
  color: rgb(129, 162, 19);
  text-decoration: underline;
}

.alertNew.status1 {
  width: 320px;
  height: 100px;
  background-color: white;
  border: 2px solid rgb(129, 162, 19);
  border-radius: 10px;
}

.alertNew .v-icon {
  display: inline-block;
  font-size: 4.1em;
  vertical-align: middle;
}

.alertNew.status0 .v-icon {
  cursor: pointer;
  animation: wiggle 0.5s infinite alternate;
  text-shadow: 0px 0px 15px white;
}

.alertNew.status0 .promoText {
  display: none;
}

.alertNew.status1 .promoText {
  padding-top: 5px;
  text-align: center;
  width: 100%;
  height: 65px;
  display: inline-block;
  vertical-align: middle;
}

.alertNew.status0 .promoClose {
  display: none;
}

.alertNew.status1 .promoClose {
  margin-top: 5px;
  padding: 4px;
  background-color: rgb(129, 162, 19);
  color: white;
  cursor: pointer;
  display: block;
  font-size: 13px;
  text-transform: capitalize;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.alertNew.status1 .promoClose span:nth-child(1) {
  display: none;
  width: 50%;
  text-align: left;
  padding-left: 8px;
}
.alertNew.status1 .promoClose span:nth-child(2) {
  display: inline-block;
  width: 100%;
  text-align: center;
  padding-right: 8px;
}

@keyframes wiggle {
  0% {
    font-size: 4.1em;
  }
  25% {
    font-size: 4.2em;
  }
  50% {
    font-size: 4.3em;
  }
  75% {
    font-size: 4.4em;
  }
  100% {
    font-size: 4.5em;
  }
}

.transparentCard {
  background-color: rgba(0, 0, 0, 0) !important;
}
.strokeme {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}

.logoBackSheet {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.6);
}

.mapBack {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}

.symbolBack {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}
.naviCard {
  position: relative;
}

.biggerFontSize {
  font-size: 1.2em;
}

.fullVH {
  height: 100vh;
}
</style>
